import { Text } from '@/components/ui/Text'

/**
 * The one shared window-truncation disclosure (ADR-011 §1/§2, PRD AC-7/AC-7e) — F1's modal and
 * G1's Bill From picker both render THIS component, not two divergent copies of its copy. Neither
 * `invoices(filter): [Invoice!]!` nor `legalEntities(...): [LegalEntityModel!]!` returns a
 * `totalCount` (bare lists), so the trigger is "returned rows == requested page size", decided by
 * each caller — this component only renders the pinned string, verbatim, once asked to.
 *
 * Bill To is deliberately NOT a consumer (AC-7c exempts it — a bounded whole-list read has no
 * window and nothing to disclose).
 */
export function ResultTruncationNotice({ className }: { className?: string }) {
  return (
    <Text variant="body-sm" color="muted" as="p" className={className}>
      More results exist than are shown. Narrow your search to see them.
    </Text>
  )
}
